// extracted by mini-css-extract-plugin
module.exports = {"container":"floating-cart_container__8W9aN","slideaTop":"floating-cart_slideaTop__PDRDQ"};